import { client } from '../apiClient';

const PROJECTS_ENDPOINT = '/onboarding';

export const canShowOnboarding = async (entry: string): Promise<boolean> => {
  return client(true, true)
    .post<boolean>(`${PROJECTS_ENDPOINT}/has-entry`, { entry })
    .then((response) => response.data)
    .catch((error) => error);
};

export const hideOnboarding = async (entry: string): Promise<boolean> => {
  return client(true, true)
    .put<boolean>(`${PROJECTS_ENDPOINT}/hide`, { entry })
    .then((response) => response.data)
    .catch((error) => error);
};
